module.exports = "<div>\n    <div class=\"modal-body\">\n        <user-profile admin-user-setup=\"true\"></user-profile>\n    </div>\n</div>";